const textFieldLogin1 = {
  email: 'Email',
  password: 'Senha'
};

export default textFieldLogin1;
